import { register } from "register-service-worker"
import bus from "./services/bus"

if (process.env.NODE_ENV === "production") {
  const log = (window.console && window.console.log) || function () {}
  const error = (window.console && window.console.error) || function () {}

  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      log("The application is being served from cache by a service worker.")
      // for more details, visit https://goo.gl/AFskqB
    },

    registered(/* registration */) {
      log("Service worker has been registered.")
    },

    cached() {
      log("The application has been cached for offline use.")
    },

    updatefound(/* registration */) {
      log("New application version is downloading.")
    },

    updated(registration) {
      log("New application version is available.")
      bus.$emit("sw:updated", registration.waiting)
    },

    offline() {
      log("No internet connection found. The application is running in offline mode.")
    },

    error(reason) {
      error("Error during service worker registration:", reason)
    }
  })

  let refreshing = false

  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (refreshing) return
    window.location.reload()
    refreshing = true
  })
}
